import {
  EVENT_TYPES,
  type BuiltInDispatchEntry
} from '@care-portals/api-interfaces';

/**
 * MD Integrations on built-in dispatch (docs/mdi-integration.md), replacing the per-org
 * `mdIntegrations.*` blueprints. Each runs the `mdi` middleware Lambda with the triggering
 * resource as `payload`.
 */
export const MdiBuiltInDispatch: BuiltInDispatchEntry[] = [
  {
    id: 'mdi-create-case',
    label: 'MD Integrations — Create Case',
    triggerEvent: EVENT_TYPES.awaiting_script,
    // Assigned to MDI, or not yet assigned but carrying an MDI product; `createCase` stamps the
    // assignment. An order assigned to another network never matches, even with an MDI product.
    triggerFilter: {
      $or: [
        { 'assignedPhysicianNetwork.key': 'mdi' },
        {
          assignedPhysicianNetwork: { $exists: false },
          lineItems: { $elemMatch: { 'extras.physicianNetwork': 'mdi' } }
        }
      ]
    },
    middlewareHandler: 'mdi',
    functionName: 'createCase',
    integrationFlag: 'isMdiEnabled',
    passPayload: true
  },
  {
    id: 'mdi-cancel-case',
    label: 'MD Integrations — Cancel Case',
    triggerEvent: EVENT_TYPES.order_cancelled,
    // Only orders that reached MDI. An MDI-side cancel moves the order to `rejected`, not
    // `cancelled`, so this never echoes a case_cancelled webhook back to MDI.
    triggerFilter: {
      'physicianNetworkVisit.source': 'mdi',
      'physicianNetworkVisit.visitId': { $exists: true }
    },
    middlewareHandler: 'mdi',
    functionName: 'cancelCase',
    integrationFlag: 'isMdiEnabled',
    passPayload: true
  },
  {
    id: 'mdi-forward-patient-message',
    label: 'MD Integrations — Forward Patient Message',
    triggerEvent: EVENT_TYPES.message_inbound,
    // Only patient-authored messages; the function skips customers with no MDI patient.
    triggerFilter: { inbound: true },
    middlewareHandler: 'mdi',
    functionName: 'forwardPatientMessage',
    integrationFlag: 'isMdiEnabled',
    passPayload: true
  }
];
